import startCase from "lodash.startcase";
import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { hexToRgbA } from "@intelligems/ig-utils";
import { Grid, useTheme } from "@mui/material";

import { ChangeLogProps, formatText } from "../utils";

export const DeleteKeyValueLine = ({ k, value }: ChangeLogProps) => {
  const theme = useTheme();
  return (
    <Grid container item className={"add-key-value-line"}>
      <Grid item sx={{ width: "100%" }}>
        <Grid
          container
          item
          alignItems={"center"}
          sx={{
            padding: "2px 16px 2px 16px",
            width: "100%",
            borderRadius: "5px",
            border: `1px solid ${hexToRgbA(theme.igBorders.core.default, 0.4)}`,
          }}
        >
          <Grid item xs={4}>
            <IgTypography sx={{ fontWeight: 600 }}>{startCase(k)}</IgTypography>
          </Grid>
          <Grid item xs={1}>
            <IgTypography>was</IgTypography>
          </Grid>
          <Grid item xs={7}>
            <IgTypography>{formatText(k, value)}</IgTypography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
